import agentReportCard from './agentReportCard';
import leadFunnel from './leadFunnel';

export default {
  AgentReportCard: agentReportCard,
  LeadFunnel: leadFunnel,
};
